<template>
  <nav v-if="totalPages > 1" class="portal-pager" aria-label="페이지 목록">
    <button
      type="button"
      class="portal-pager__nav"
      :disabled="modelValue <= 1"
      aria-label="첫 페이지"
      @click="go(1)"
    >
      <AppIcon icon="mdi-chevron-double-left" :size="18" />
    </button>
    <button
      type="button"
      class="portal-pager__nav"
      :disabled="modelValue <= 1"
      aria-label="이전 페이지"
      @click="go(modelValue - 1)"
    >
      <AppIcon icon="mdi-chevron-left" :size="18" />
    </button>

    <button
      v-for="p in pages"
      :key="p"
      type="button"
      class="portal-pager__page"
      :class="{ 'is-active': p === modelValue }"
      :aria-current="p === modelValue ? 'page' : undefined"
      @click="go(p)"
    >
      {{ p }}
    </button>

    <button
      type="button"
      class="portal-pager__nav"
      :disabled="modelValue >= totalPages"
      aria-label="다음 페이지"
      @click="go(modelValue + 1)"
    >
      <AppIcon icon="mdi-chevron-right" :size="18" />
    </button>
    <button
      type="button"
      class="portal-pager__nav"
      :disabled="modelValue >= totalPages"
      aria-label="마지막 페이지"
      @click="go(totalPages)"
    >
      <AppIcon icon="mdi-chevron-double-right" :size="18" />
    </button>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'

const props = withDefaults(
  defineProps<{ modelValue: number; totalPages: number; window?: number }>(),
  { window: 5 },
)

const emit = defineEmits<{ (e: 'update:modelValue', value: number): void }>()

const pages = computed(() => {
  const size = props.window
  let start = Math.max(1, props.modelValue - Math.floor(size / 2))
  const end = Math.min(props.totalPages, start + size - 1)
  start = Math.max(1, end - size + 1)
  const list: number[] = []
  for (let p = start; p <= end; p += 1) list.push(p)
  return list
})

function go(target: number) {
  const next = Math.min(Math.max(1, target), props.totalPages)
  if (next !== props.modelValue) emit('update:modelValue', next)
}
</script>

<style lang="scss" src="./PortalPager.scss"></style>
